<template>
  <div class="flex items-baseline">
    <div class="flex-1">
      <div
        class="rounded p-3"
        :class="{
          'bg-purple-200': selected,
          'bg-gray-100': !selected,
        }"
      >
        <div class="flex -mx-3 items-baseline">
          <div class="flex-1 px-4 py-2">
            <span class="block">{{ entity.name }}</span>
          </div>
          <div class="flex-none px-4">
            <BaseLinkButton v-if="!selected" silver @click="upgrade">
              Επιλογη (+{{ priceDiff }} &euro;)
            </BaseLinkButton>

            <BaseLinkButton v-else silver @click="downgrade"> Καταργηση </BaseLinkButton>
          </div>
        </div>
      </div>
    </div>
    <div v-if="selected" class="w-24 p-3 font-medium text-right">
      <span> {{ entity.price }} &euro; </span>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'ProductServiceUpgrade',
  props: {
    entity: {
      type: Object,
      required: true,
    },
    selected: Boolean,
  },
  data: () => ({
    customize: false,
  }),
  computed: {
    ...mapState('entities', {
      productsById: (state) => state.productServices.byId,
    }),
    product() {
      return this.productsById[this.entity.upgradesProductServiceUuid] || null;
    },
    priceDiff() {
      const { price = 0 } = this.product || {};

      return this.entity.price - price;
    },
  },
  methods: {
    upgrade() {
      this.$emit('upgrade', { ...this.entity });
    },
    downgrade() {
      this.$emit('downgrade', { ...this.entity });
    },
  },
};
</script>
